type ClassListAction = 'add' | 'remove';

const mutateBodyClassList = (action: ClassListAction) => () => document.body.classList[action]('prevent-scroll');

export const preventBodyScroll: {
  (action: 'add'): () => void;
  (action: 'remove'): () => void;
  reset: () => void;
} = (action: ClassListAction) => {
  const mutationFunction = mutateBodyClassList(action);
  return mutationFunction;
};

preventBodyScroll.reset = mutateBodyClassList('remove');
